<template>
    <article>
        <h1>Datenschutz</h1>

        <h2>Geltungsbereich</h2>
        <p>
            Die folgende Datenschutzerklärung gilt für unsere Website sowie für unsere Social-Media-Seiten unter den folgenden URLs:
        </p>
        <ul>
            <li><nuxt-link to="https://www.tauschwohnung.com" target="_blank">Website</nuxt-link></li>
            <li><nuxt-link to="https://www.facebook.com/tauschwohnung" target="_blank">Facebook</nuxt-link></li>
            <li><nuxt-link to="https://www.instagram.com/tauschwohnung" target="_blank">Instagram</nuxt-link></li>
            <li><nuxt-link to="https://www.youtube.com/@tauschwohnung" target="_blank">YouTube</nuxt-link></li>
            <li><nuxt-link to="https://www.pinterest.de/tauschwohnung/" target="_blank">Pinterest</nuxt-link></li>
            <li><nuxt-link to="https://www.tiktok.com/@tauschwohnung" target="_blank">TikTok</nuxt-link></li>
            <li><nuxt-link to="https://de.linkedin.com/company/tauschwohnung" target="_blank">LinkedIn</nuxt-link></li>
        </ul>

        <hr>

        <p>
            <strong>Wir</strong> als Betreiber der Website unter www.tauschwohnung.com (auch
            „<strong>Website</strong>“ bzw. „<strong>Online-Shop</strong>“) sind
            <strong>Verantwortliche</strong> im Sinne des geltenden Datenschutzrechts, insbesondere der
            Datenschutz-Grundverordnung („DSGVO“), für die personenbezogenen Daten des Nutzers
            („<strong>Sie</strong>“) dieser Website.
        </p>
        <p>
            Im Folgenden unterrichten wir Sie übersichtlich im Rahmen unserer Informationspflichten (Art. 13 ff.
            DSGVO) darüber, welche Daten bei Ihrem Besuch unserer Website verarbeitet werden und auf welcher
            Rechtsgrundlage dies geschieht. Sie erhalten außerdem Informationen darüber, welche Rechte Sie
            gegenüber uns und gegenüber der zuständigen Aufsichtsbehörde haben.
        </p>

        <h2>1. Informationen zum Verantwortlichen</h2>

        <tw-company-info />

        <h2>2. Verarbeitung Ihrer personenbezogenen Daten </h2>

        <p>Einleitend möchten wir darauf hinweisen, dass wir ggf. bei der Verarbeitung Ihrer personenbezogener
            Daten Dienstleister einsetzen, mit denen wir Auftragsverarbeitungsverträge abgeschlossen haben.
            Sofern Auftragsverarbeiter in einem Drittstaat (nicht innerhalb der EU) die Datenverarbeitung
            vornehmen, stellen wir sicher, dass das durch die DSGVO gewährleistete Schutzniveau Ihrer Daten
            nicht untergraben wird (Art. 44 ff DSGVO).</p>

        <h2>3. Informatorische Nutzung unserer Website </h2>

        <p>Wenn Sie unsere Website aufrufen, um sie lediglich zu besuchen, werden so genannte
            <strong>Logfiles</strong> verarbeitet, indem sie von unserem System automatisiert erfasst werden.
        </p>

        <p>Folgende Logfiles werden <strong>automatisiert</strong> verarbeitet:</p>

        <ul>
            <li>IP-Adresse des anfragenden Rechners</li>
            <li>Typ des verwendeten Internet-Browsers</li>
            <li>Sprache des verwendeten Internet-Browsers</li>
            <li>Version des verwendeten Internet-Browsers</li>
            <li>Betriebssystem und dessen Version</li>
            <li>Oberfläche des Betriebssystems</li>
            <li>Aufgerufene Seiten</li>
            <li>Datum und Uhrzeit des Besuchs</li>
            <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
            <li>Zugriffstatus/http-Statuscode</li>
            <li>Übertragene Datenmenge</li>
            <li>Erfolg bzw. Fehler des Ladevorgangs</li>
            <li>Referrer</li>
            <li>Websites, die vom System des Besuchers über unsere Website aufgerufen werden</li>
            <li>Internet-Service-Provider des Nutzers</li>
        </ul>

        <p>Die Logfiles enthalten Ihre IP-Adresse und möglicherweise weitere personenbezogene Daten. Daher ist
            eine Zuordnung zu Ihnen grundsätzlich möglich. Wir speichern Ihre Daten jedoch nur vorübergehend und
            insbesondere nicht zusammen mit anderen personenbezogenen Daten.</p>

        <p>Für die Bereitstellung unserer Website ist die Verarbeitung der oben genannten Daten erforderlich.
            Wir speichern die Daten auch zum Zwecke der Sicherheit unserer informationstechnischen Systeme. In
            diesen Zwecken ist auch unser berechtigtes Interesse begründet, die Daten auf der
            <strong>Rechtsgrundlage</strong>
            Art. 6 (1) lit. f DSGVO zu verarbeiten. Die Logfiles, in denen auch Ihre IP-Adresse enthalten ist
            werden unverzüglich gelöscht, nachdem sie zur Erreichung der vorgenannten Zwecke nicht mehr
            erforderlich sind und spätestens nach sieben Tagen anonymisiert.
        </p>


        <h2>4. Nutzung von Angeboten</h2>

        <h4>4.1. Registrierung</h4>

        <p>Sie haben die Möglichkeit, auf unserer Website mit Ihren personenbezogenen Daten ein Kundenkonto
            anzulegen. Wenn Sie sich für ein Kundenkonto entscheiden, müssen Sie uns folgende Angaben zur
            Verfügung stellen: </p>

        <ul>
            <li>E-Mail-Adresse</li>
            <li>Vor- und Nachname</li>
        </ul>

        <p>Wenn Sie Ihre <strong>Registrierung</strong> abschicken, speichern wir zusammen mit Ihren angegebenen
            Daten Ihre <strong>IP-Adresse und Datum und Zeitpunkt Ihrer Registrierung</strong>. Mit dem Absenden
            der Registrierung stimmen Sie der Verarbeitung Ihrer Daten durch uns zu.</p>

        <p>Wir erheben automatisch Informationen über Ihre Antwortrate und Antwortzeit auf Nachrichten, wenn
            Nutzer mit Ihnen in Kontakt treten.</p>

        <p>Ihre Daten werden zum Zwecke der Verwaltung Ihres Kundenkontos und Bereitstellung der damit
            verbundenen Funktionen, wie z.B. die Bearbeitung Ihrer Kundendaten, und die Anzeige Ihrer
            Bestellungen verwendet. Die <strong>Rechtsgrundlage</strong> für die Speicherung Ihrer
            Kundenkonto-Daten ist Art. 6 (1) lit. a DSGVO.</p>

        <p>Wir speichern Ihre Daten, die Sie uns im Rahmen Ihrer freiwilligen Registrierung zur Verfügung
            gestellt haben, solange Sie Ihr Kundenkonto bei uns nicht löschen. Wenn Sie Änderungen an Ihren
            Angaben vornehmen, werden die alten Angaben gelöscht und nur die aktualisierten Daten gespeichert.
            Darüberhinausgehend speichern wir Ihre Daten nur, um unseren vertraglichen oder gesetzlichen
            Verpflichtungen (z.B. steuerlichen Pflichten) nachzukommen (Art. 6 (1) lit. c DSGVO). In diesem Fall
            sperren wir Ihre Daten insoweit, als dass sie nur noch für die notwendigen Zwecke verarbeitet
            werden. Zusätzlich zu diesen Daten speichern wir den Zeitpunkt (Datum und Uhrzeit) der Übermittlung
            Ihrer Daten an uns, sowie Ihre IP-Adresse. Die Verarbeitung dieser Daten entspricht unserem
            berechtigten Interesse (Art. 6 (1) lit. f DSGVO), um die Sicherheit unserer Systeme zu gewährleisten
            und Missbrauch entgegenzuwirken. Diese zusätzlichen Daten werden gelöscht, sobald sie nicht mehr
            benötigt werden, spätestens wenn der Vertrag mit Ihnen abgewickelt ist.
            Sie können jederzeit Ihr freiwilliges Kundenkonto bei uns löschen oder abändern. Sie finden die
            Funktionen zur Änderung Ihrer Angaben oder Auflösung Ihres Kontos in Ihrem Profil . </p>

        <p><strong>Social Sign-In mit Facebook</strong><br>
            nutzen die offizielle Bibliothek der Plattform von Facebook Ireland Ltd., 4 Grand Canal Square,
            Grand Canal Harbour, Dublin 2, Ireland (im Folgenden: <strong>Facebook</strong>), um unsere
            Plattform mit den Diensten von Facebook zu verbinden. Wir bieten Ihnen darüber die Möglichkeit, sich
            mit Ihrem Social-Media-Profil bei Facebook auf unserer Plattform zu registrieren und anzumelden.
            Wenn Sie diese Funktion nutzen, erhält Facebook die Information, dass Sie sich auf unserer Plattform
            registriert und/oder angemeldet haben und es kann sein, dass Facebook auch weitere personenbezogene
            Daten (z.B. über Ihr mobiles Endgerät) verarbeitet.</p>

        <p>Die Anmeldung über eine Plattform ist freiwillig. Wir stellen dieses Angebot und eine dadurch
            verbundene Datenverarbeitung durch die Plattformen zur Verfügung, um Ihnen eine Anmeldung zu
            erleichtern. <strong>Rechtsgrundlage</strong> für die Datenverarbeitung ist Art. 6 (1) S. 1. lit. f
            DSGVO. </p>

        <h4>4.2. Tauschgesuch</h4>

        <p>Auf unserer Plattform können Sie ein Gesuch einstellen, um einen geeigneten Tauschpartner zu finden.
            Wenn Sie sich dazu entscheiden ein Konto bei uns anzulegen, müssen Sie uns Angaben bezüglich Ihres
            Gesuchs zur Verfügung stellen. Dies betrifft Angaben über gewünschte Eigenschaften der
            Tauschwohnung, die andere Nutzer der Plattform einsehen können.</p>

        <p>Nach der Registrierung auf unserer Plattform können Sie uns Informationen über Eigenschaften Ihrer
            gewünschten Wohnung zur Verfügung stellen:</p>
        <ul>
            <li>Ort (und Umgebungsradius)</li>
            <li>Art der Wohnung (Wohnung, WG-Zimmer, Haus)</li>
            <li>Angaben über Eigenschaften der Wohnung (z.B. Kaltmiete)</li>
        </ul>

        <p>Für einen Wohnungstausch müssen Sie uns außerdem folgende Informationen über Ihre derzeitige
            Wohnsituation zur Verfügung stellen:</p>
        <ul>
            <li>Postleitzahl, Straße und Hausnummer</li>
            <li>Art der Wohnung</li>
            <li>Mietkosten (Kaltmiete und Nebenkosten)</li>
            <li>Anzahl der Zimmer</li>
            <li>Wohnfläche</li>
            <li>Etage</li>
        </ul>

        <p>Alle weiteren Angaben sind freiwillig. Folgende freiwillige Angaben speichern wir zusammen mit Ihrer
            E-Mail-Adresse, wenn Sie sie uns zur Verfügung stellen:</p>
        <ul>
            <li>Eigenschaften der Wohnung</li>
            <li>Beschreibung der Wohnsituation</li>
            <li>Titel des Tauschgesuchs</li>
            <li>Lichtbilder</li>
        </ul>

        <p>Wenn Sie mit anderen Benutzern Kontakt aufnehmen, beispielsweise um einen Wohnungstausch zu
            besprechen, können andere Benutzer der Plattform Ihren Vornamen sehen.</p>

        <p>Ihre Daten werden zum Zwecke der Bereitstellung der Funktionen der Plattform, wie z.B. die Anzeige
            und Bearbeitung Ihres Tauschgesuchs verarbeitet. Die Rechtsgrundlage für die Speicherung Ihrer Daten
            für ein Tauschgesuch ist Art. 6 (1) lit. b DSGVO.</p>

        <p>Wir speichern Ihre Daten, die Sie uns im Rahmen Ihres Gesuchs zur Verfügung gestellt haben, solange
            Sie Ihr Kundenkonto bei uns nicht löschen. Wenn Sie Änderungen an Ihren Angaben vornehmen, werden
            die alten Angaben gelöscht und nur die aktualisierten Daten gespeichert. Darüberhinausgehend
            speichern wir Ihre Daten nur, um unseren vertraglichen oder gesetzlichen Verpflichtungen (z.B.
            steuerlichen Pflichten) nachzukommen (Art. 6 (1) lit. c DSGVO). In diesem Fall sperren wir Ihre
            Daten insoweit, als dass sie nur noch für die notwendigen Zwecke verarbeitet werden.</p>

        <h4>4.3. Zahlungsmethoden</h4>
        <p>Wenn Sie auf unserer Seite zur Bezahlung einen Payment-Anbieter auswählen, erhält auch dieser
            Anbieter Ihre personenbezogenen Daten, beispielsweise Ihren Namen, Ihre Adresse und Ihre
            Kontoverbindung. Außerdem erhält unsere Hausbank Ihre Bankverbindungsdaten, wenn eine elektronische
            Zahlung eingeht. </p>

        <p><strong>PayPal:</strong> Wenn Sie auf unserer Website mit PayPal (PayPal (Europe) S.à r.l. et Cie,
            S.C.A. 22-24 Boulevard Royal L-2449 Luxembourg) bezahlen, erhält PayPal zur Zahlungsabwicklung Ihre
            Zahlungsdaten und es kann sein, dass PayPal eine Bonitätsprüfung durchführt. Informationen dazu
            finden Sie unter:</p>
        <p><nuxt-link to="https://www.paypal.com/de/webapps/mpp/ua/privacy-full?locale.x=de_DE#rAnnex"
                target="_blank">https://www.paypal.com/de/webapps/mpp/ua/privacy-full?locale.x=de_DE#rAnnex</nuxt-link>.
        </p>

        <p><strong>Kreditkarte:</strong> Wenn Sie auf unserer Website mit Ihrer Kreditkarte bezahlen, erhält Ihr
            Kreditkartenanbieter die Information, dass Sie bei uns eine Bestellung getätigt haben. Es kann sein,
            dass Ihr Kreditkartenanbieter eine Bonitätsprüfung durchführt. Nähere Informationen hierzu finden
            Sie auf der jeweiligen Website Ihres Kreditkartenanbieters.</p>

        <p><strong>Mollie:</strong></p>

        <p>Wir bieten auf unserer Webseite verschiedene Zahlungsmethoden (bei einmaliger Zahlung -
            Sofortüberweisung, Apple Pay, Kreditkarte, PayPal, iDEAL, SEPA Banküberweisung, SEPA Lastschrift,
            Apple
            Pay / bei regelmäßiger Zahlung - Sofortüberweisung, Apple Pay, Kreditkarte, PayPal, iDEAL) an,
            wobei die
            Abwicklung dieser
            Zahlungsmethoden über den Online-Zahlungsdienst der Firma Mollie B.V. Keizersgracht 126, 1015CW
            Amsterdam, Niederlande, E-Mail: info@mollie.com, erfolgt.</p>

        <p>Wenn Sie eine der vorstehend benannten Bezahlmethode auswählen, welche über Mollie angeboten wird,
            werden die von Ihnen eingegebenen Zahlungsdaten an die Firma Mollie übermittelt und von Mollie
            weiterverarbeitet.</p>

        <p>Informationen über Art, Umfang und Zweck der Erhebung und Verwendung personenbezogener Daten durch
            Mollie sowie Ihre diesbezüglichen Rechte gegenüber Mollie können Sie der Datenschutzrichtlinie von
            Mollie unter der folgenden URL entnehmen:</p>
        <p><nuxt-link to="https://www.mollie.com/de/privacy"
                target="_blank">https://www.mollie.com/de/privacy</nuxt-link>
        </p>

        <p>Der vorstehend beschriebene Einsatz von Mollie erfolgt zur Bezahlung und damit auf der Rechtsgrundlage
            von Art. 6 Abs. 1 lit. b DSGVO zur Erfüllung eines Vertrags. Darüber hinaus erfolgt der Einsatz des
            Zahlungsdiensteanbieters Mollie aufgrund unseres berechtigten Interesses und damit auf der
            Rechtsgrundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes wirtschaftliches Interesse liegt
            darin, den Nutzern unseres Dienstes komfortable Online-Zahlungen anzubieten.</p>


        <h4>4.4. Kontaktformular / Feedback</h4>
        <p>Sie können uns auf elektronischem Wege über unser Kontaktformular kontaktieren, bspw. um uns Feedback
            mitzuteilen oder um uns Fragen zu stellen. Wenn Sie diese Möglichkeit nutzen, übermitteln Sie
            folgende Daten an uns: </p>
        <ul>
            <li>E-Mailadresse (um mit Ihnen Kontakt aufzunehmen)
            </li>
            <li>Vor- und Zunamen (um Sie anzusprechen und zu Zwecken der Missbrauchsprävention)
            </li>
        </ul>
        <p>Zusätzlich zu den Daten, die Sie uns freiwillig mitteilen, speichern wir den Zeitpunkt (Datum und
            Uhrzeit) der Übermittlung Ihrer Daten an uns, sowie Ihre IP-Adresse. Die Verarbeitung dieser Daten
            entspricht unserem berechtigten Interesse (Art. 6 (1) lit. f DSGVO), um die Sicherheit unserer
            Systeme zu gewährleisten und Missbrauch entgegenzuwirken. Diese Daten, die wir während Ihrer
            Kontaktaufnahme zusätzlich erheben, werden gelöscht, sobald sie nicht mehr benötigt werden,
            spätestens wenn das Anliegen Ihrer Kontaktaufnahme umfassend geklärt ist.</p>

        <p>Mit dem Absenden des Kontaktformulars stimmen Sie der Verarbeitung Ihrer Daten durch uns zu. Die
            <strong>Rechtsgrundlage</strong> für die Verarbeitung Ihrer Daten zum Zwecke der Bearbeitung Ihrer
            Kontaktaufnahme ist Art. 6 (1) lit. a DSGVO. Die Daten werden gespeichert, bis sie zur Erreichung
            des Zwecks der Konversation mit Ihnen nicht mehr erforderlich sind und das Anliegen Ihrer
            Kontaktaufnahme umfassend geklärt ist.
        </p>

        <p>Wenn Ihre Kontaktaufnahme darauf abzielt, einen Vertrag mit uns abzuschließen, ist die zusätzliche
            <strong>Rechtsgrundlage</strong> für die Verarbeitung Ihrer personenbezogenen Daten Art. 6 (1) lit.
            b DSGVO. Diese Daten werden so lange gespeichert, wie sie zur Durchführung des Vertrags erforderlich
            sind. Darüberhinausgehend speichern wir Ihre Daten nur, um vertraglichen oder gesetzlichen
            Verpflichtungen (z.B. steuerlichen Pflichten) nachzukommen (Art. 6 (1) lit. c DSGVO).
        </p>

        <h4>4.5. Kontaktaufnahme per E-Mail oder Telefon</h4>
        <p>Sie haben die Möglichkeit, uns per <strong>E-Mail oder Telefon</strong> zu kontaktieren. Ihre auf
            diesem Wege übermittelten personenbezogenen Daten werden bei uns gespeichert. Die Daten werden
            ausschließlich verarbeitet, um Ihre Kontaktaufnahme zu bearbeiten. Die
            <strong>Rechtsgrundlage</strong> für die Verarbeitung Ihrer personenbezogenen Daten ist Art. 6 (1)
            lit. f DSGVO. Die Daten werden gespeichert, bis sie zur Erreichung des Zwecks der Konversation mit
            Ihnen nicht mehr erforderlich sind und das Anliegen Ihrer Kontaktaufnahme umfassend geklärt ist.
        </p>

        <p>Wenn Ihre Kontaktaufnahme darauf abzielt, einen Vertrag mit uns abzuschließen, ist die zusätzliche
            <strong>Rechtsgrundlage</strong> für die Verarbeitung Ihrer personenbezogenen Daten Art. 6 (1) lit.
            b DSGVO. Diese Daten werden so lange gespeichert, wie sie zur Durchführung des Vertrags erforderlich
            sind. Darüberhinausgehend speichern wir Ihre Daten nur, um vertraglichen oder gesetzlichen
            Verpflichtungen (z.B. steuerlichen Pflichten) nachzukommen (Art. 6 (1) lit. c DSGVO).
        </p>

        <p>Zusätzlich zu den Daten, die Sie uns freiwillig mitteilen, erhalten wir ggf. den Zeitpunkt (Datum und
            Uhrzeit) der Übermittlung Ihrer Daten an uns, sowie Ihre IP-Adresse. Die Verarbeitung dieser Daten
            entspricht unserem berechtigten Interesse (Art. 6 (1) lit. f DSGVO), um die Sicherheit unserer
            Systeme zu gewährleisten und Missbrauch entgegenzuwirken. Diese Daten, die wir während Ihrer
            Kontaktaufnahme zusätzlich erheben, werden gelöscht, sobald sie nicht mehr benötigt werden,
            spätestens wenn das Anliegen Ihrer Kontaktaufnahme umfassend geklärt ist.</p>

        <p>Sie können uns jederzeit mitteilen (siehe oben Ziffer 1), dass wir die im Rahmen der Konversation
            mitgeteilten Daten löschen sollen. In diesem Fall werden, soweit zulässig, alle personenbezogenen
            Daten der Konversation gelöscht und eine Fortführung der Konversation ist nicht möglich.</p>

        <h4>4.6. Newsletter</h4>
        <p>Wenn Sie bei der Inanspruchnahme unserer Dienste, beispielsweise der Registrierung auf unserer
            Website, Ihre E-Mail-Adresse angeben, kann diese von uns für den Newsletter-Versand verwendet
            werden. Dies geschieht ausschließlich im Rahmen von Direktwerbung für eigene oder ähnliche Waren
            oder Dienstleistungen.
            Die <strong>Rechtsgrundlage</strong> für den Newsletter-Versand im Zusammenhang mit dem Verkauf von
            Waren oder Dienstleistungen ist Art. 6 Abs. 1 lit. f) DSGVO i.V.m. § 7 (3) UWG. Wenn wir Ihnen im
            Anschluss an eine Bestellung auf unserer Website einen Newsletter schicken, speichern wir Ihre
            E-Mail-Adresse zum Zwecke der Werbung für eigene oder ähnliche Waren oder Dienstleistungen, bis Sie
            sich vom Newsletter abmelden. </p>

        <p><strong>Widerspruchsmöglichkeit / Newsletter abbestellen</strong><br>
            Sie können unseren Newsletter jederzeit abbestellen bzw. kündigen. Den Link dazu finden Sie am Ende
            jeden Newsletters. Hierdurch widerrufen Sie Ihre Einwilligung bzw. widersprechen einer weiteren
            Verwendung Ihrer Daten zum Zwecke des Newsletter-Versands.</p>

        <h2>5. Cookies</h2>

        <p>Sie können die Einstellungen über Cookies mit dem Klick auf folgenden Link verwalten
            <tw-link-cookie-consent>Cookie Consent Verwaltung</tw-link-cookie-consent>.
        </p>
        <p> Bitte beachten Sie folgenden Hinweis: Sie können selbst dafür sorgen, dass überhaupt keine Cookies
                auf Ihrem Rechner gespeichert werden, oder dass die Speicherung nur von bestimmten Cookies
                zugelassen wird. Dies können Sie in Ihren Internetbrowser-Einstellungen auswählen. Sie können dort
                auch die gespeicherten Cookies einsehen und löschen.
                Wenn Sie alle Cookies blockieren, kann es sein, dass Ihnen nicht alle Funktionen unserer Website zur
                Verfügung stehen.</p>
            <p>
                Wir verwenden auf unserer Website Cookies. Cookies sind Textdateien, die im Rahmen Ihres Besuchs
                unserer Website von unserem Webserver an Ihren Browser gesandt und von diesem auf Ihrem Rechner für
                einen späteren Abruf vorgehalten werden. Durch ein Cookie kann Ihr Internetbrowser also
                identifiziert werden, wenn Sie die Website erneut aufrufen. Es gibt Session-Cookies, das sind
                solche, die sich bei Schließen des Browsers wieder löschen und es gibt persistente Cookies, die auf
                der Festplatte gespeichert werden, bis ihr voreingestelltes Ablaufdatum erreicht ist oder bis sie
                aktiv durch Sie entfernt werden. </p>

            <p id="cookie-liste"><strong>Übersicht der verwendeten Cookies:</strong></p>

            <div class="cmpcookieinfof687c57761de cmpstyleroot"></div>


        <h2>6. Social Media</h2>

        <h4>6.1. Icon-Links zu Social Networks </h4>
            <p>Auf unserer Website setzen wir kleine Icons ein, die jeweils auf unseren Webauftritt auf Plattformen von Dritten (Facebook, TikTok, LinkedIn, X [ehemals Twitter], Instagram, YouTube) verweisen. Es handelt sich jeweils um Hyperlinks, sodass keine Daten von Ihnen automatisch übertragen werden. Erst wenn Sie auf die Icons klicken, öffnet sich in Ihrem Browser ein neuer Tab mit der Website des jeweiligen Drittanbieters.</p>

            <h4>6.2. Social Media Fanpages</h4>
            <p>
              Wir betreiben offizielle Fanpages auf folgenden Social-Media-Plattformen:
            </p>
            <ul>
                <li><strong>Facebook</strong> (Meta Platforms Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, D2 Dublin, Ireland)</li>
                <li><strong>Instagram</strong> (Meta Platforms Ireland Ltd.)</li>
                <li><strong>TikTok</strong> (TikTok Technology Limited, 10 Earlsfort Terrace, Dublin, D02 T380, Ireland)</li>
                <li><strong>LinkedIn</strong> (LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Ireland)</li>
                <li><strong>X (ehemals Twitter)</strong> (Twitter International Unlimited Company, One Cumberland Place, Fenian Street, Dublin 2, Ireland)</li>
                <li><strong>YouTube</strong> (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland)</li>
            </ul>

            <p>
                Solange Sie nicht auf den jeweiligen Link klicken, erhält die jeweilige Plattform keine Daten von Ihnen. Wenn Sie den Link anklicken,
                um beispielsweise unseren Unternehmensauftritt anzusehen oder unserer Seite zu folgen, erhält die Plattform Daten von Ihnen.
                Welche Daten erhoben werden, hängt davon ab, ob Sie mit Ihrem Nutzerprofil eingeloggt sind oder nicht.
            </p>

            <p>
                Jede Plattform verarbeitet die erhobenen Daten in eigener Verantwortung. Wir erhalten von den Plattformen nur aggregierte und anonymisierte
                Statistiken (z. B. „Page Insights“ bei Facebook). Weitere Informationen zur Datenverarbeitung der einzelnen Plattformen finden Sie in den
                jeweiligen Datenschutzrichtlinien:
            </p>

            <ul>
              <li><strong><nuxt-link to="https://www.facebook.com/privacy/policy" target="_blank">Facebook & Instagram</nuxt-link></strong></li>
              <li><strong><nuxt-link to="https://www.tiktok.com/legal/page/eea/privacy-policy/en" target="_blank">TikTok</nuxt-link></strong></li>
              <li><strong><nuxt-link to="https://www.linkedin.com/legal/privacy-policy" target="_blank">LinkedIn</nuxt-link></strong></li>
              <li><strong><nuxt-link to="https://twitter.com/en/privacy" target="_blank">X (Twitter)</nuxt-link></strong></li>
              <li><strong><nuxt-link to="https://policies.google.com/privacy" target="_blank">YouTube (Google)</nuxt-link></strong></li>
          </ul>

            <p>
                In der Nutzung und Verknüpfung unterschiedlicher Kommunikationskanäle liegt unser berechtigtes Interesse an der Verarbeitung
                personenbezogener Daten. Die Verarbeitung erfolgt auf der <strong>Rechtsgrundlage</strong> von Art. 6 Abs. 1 lit. f DSGVO.
            </p>

            <p>
                Falls Sie eine Anfrage bezüglich unserer Social-Media-Präsenzen haben, können Sie uns jederzeit kontaktieren.
            </p>


        <h2>7. Ihre Rechte</h2>

        <p>Wenn wir Ihre Daten verarbeiten, sind Sie „Betroffener“ im Sinne der DSGVO. Ihnen stehen folgende
            Rechte zu: <strong>Auskunftsrecht</strong>, Recht auf <strong>Berichtigung</strong>, Recht auf
            <strong>Einschränkung</strong> der Verarbeitung, Recht auf <strong>Löschung</strong>, Recht auf
            <strong>Unterrichtung</strong> sowie Recht auf <strong>Datenübertragbarkeit</strong>. Darüber hinaus
            haben Sie ein <strong>Widerspruchsrecht</strong> und ein <strong>Widerrufsrecht</strong> und das
            Recht, sich bei der <strong>Aufsichtsbehörde</strong> zu beschweren.
        </p>

        <p>Im Folgenden finden Sie Details zu den einzelnen Rechten:</p>

        <h4>a. Auskunftsrecht</h4>
        <p>Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob wir Ihre personenbezogenen
            Daten verarbeiten. Sofern wir Ihre personenbezogenen Daten verarbeiten, haben Sie das Recht,
            Auskunft über folgende Informationen zu erhalten:
        </p>
        <p>

        </p>
        <ul>
            <li>die Verarbeitungszwecke</li>
            <li>die Kategorien personenbezogener Daten, die verarbeitet werden;</li>
            <li>die Empfänger oder Kategorien von Empfängern, gegenüber denen Ihre personenbezogenen Daten
                offengelegt worden sind oder noch offengelegt werden, insbesondere bei Empfängern in
                Drittländern oder bei internationalen Organisationen;
            </li>
            <li>falls möglich die geplante Dauer, für die Ihre personenbezogenen Daten gespeichert werden, oder,
                falls dies nicht möglich ist, die Kriterien für die Festlegung dieser Dauer;
            </li>
            <li>das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden personenbezogenen
                Daten oder auf Einschränkung der Verarbeitung durch uns oder eines Widerspruchsrechts gegen
                diese Verarbeitung;
            </li>
            <li>das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;</li>
            <li>wenn die personenbezogenen Daten nicht direkt bei Ihnen erhoben wurden, alle verfügbaren
                Informationen über die Herkunft der Daten;
            </li>
            <li>das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling gemäß Art. 22
                (1) und (4) DSGVO und – zumindest in diesen Fällen – aussagekräftige Informationen über die
                involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen einer derartigen
                Verarbeitung für Sie.
            </li>
        </ul>
        <p>Falls wir Ihre Daten an eine internationale Organisation oder in ein Drittland übermitteln haben Sie
            ferner das Recht, darüber Auskunft zu verlangen, ob geeignete Garantien gem. Art. 46 DSGVO im
            Zusammenhang mit der Übermittlung bestehen.</p>

        <h4>b. Berichtigungsrecht</h4>
        <p>Sie haben das Recht auf Berichtigung und/oder Vervollständigung der Daten, die wir über Sie
            gespeichert haben, wenn diese Daten unrichtig oder unvollständig sind. Wir nehmen die Berichtigung
            oder Vervollständigung unverzüglich vor. </p>

        <h4>c. Recht zur Einschränkung der Verarbeitung</h4>
        <p>Unter bestimmten Voraussetzungen haben Sie das Recht, von uns die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen. Dafür muss mindestens eine der nachfolgenden
            Voraussetzungen erfüllt sein: </p>

        <ul>
            <li>Sie bestreiten die Richtigkeit der personenbezogenen Daten, und zwar für eine Dauer, die es uns
                ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen,
            </li>
            <li>Die Verarbeitung ist unrechtmäßig und Sie lehnen die Löschung der personenbezogenen Daten ab und
                stattdessen verlangen Sie die Einschränkung der Nutzung der personenbezogenen Daten;
            </li>
            <li>Wir benötigen die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger, Sie
                jedoch benötigen diese zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen, oder
            </li>
            <li>Sie haben Widerspruch gegen die Verarbeitung gemäß Art. 21 (1) DSGVO eingelegt, solange noch
                nicht feststeht, ob unsere berechtigten Gründe gegenüber Ihren Interessen überwiegen.
            </li>
        </ul>

        <h4>d. Löschungsrecht</h4>
        <p>Sie haben das Recht, von uns zu verlangen, dass wir Ihre personenbezogenen Daten unverzüglich
            löschen, wenn wir dazu verpflichtet sind. Dies ist der Fall, wenn eine der nachfolgenden
            Voraussetzungen erfüllt ist:</p>

        <ul>
            <li>Ihre personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise
                verarbeitet wurden, nicht mehr notwendig.
            </li>
            <li>Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gemäß Art. 6 (1) lit. a oder
                Art. 9 (2) lit. a DSGVO stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die
                Verarbeitung.
            </li>
            <li>Sie legen gemäß Art. 21 (1) DSGVO Widerspruch gegen die Verarbeitung ein und es liegen keine
                vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen gemäß Art. 21 (2) DSGVO
                Widerspruch gegen die Verarbeitung ein.
            </li>
            <li>Ihre personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>
            <li>Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach
                dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem wir unterliegen.
            </li>
            <li>Ihre personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft
                gemäß Art. 8 (1) DSGVO erhoben.
            </li>
        </ul>
        <p></p>
        <p>Wenn wir Ihre personenbezogenen Daten öffentlich gemacht haben und wir gemäß den vorgenannten
            Voraussetzungen zur Löschung verpflichtet sind, so treffen wir unter Berücksichtigung der uns
            verfügbaren Technologien und Implementierungskosten angemessene Maßnahmen, auch technischer Art, um
            andere für die Datenverarbeitung Verantwortliche, die die personenbezogenen Daten verarbeiten,
            darüber zu informieren, dass Sie von uns die Löschung aller Links zu diesen personenbezogenen Daten
            oder von Kopien oder Replikationen dieser personenbezogenen Daten verlangt haben.</p>

        <p>Ihr Recht auf Löschung besteht jedoch dann nicht, wenn die Verarbeitung aus den nachfolgenden Gründen
            (Ausnahmen) erforderlich ist: </p>

        <ul>
            <li>Zur Ausübung des Rechts auf freie Meinungsäußerung und Information;</li>
            <li>zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht der Union
                oder der Mitgliedstaaten, dem wir unterliegen, erfordert, oder zur Wahrnehmung einer Aufgabe,
                die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die uns
                übertragen wurde;
            </li>
            <li>aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit gemäß Art. 9 (2)
                lit. h und i sowie Art. 9 (3) DSGVO;
            </li>
            <li>für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder historische
                Forschungszwecke oder für statistische Zwecke gemäß Art. 89 (1) DSGVO, soweit das in (1)
                genannte Recht voraussichtlich die Verwirklichung der Ziele dieser Verarbeitung unmöglich macht
                oder ernsthaft beeinträchtigt, oder
            </li>
            <li>zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</li>
        </ul>

        <h4>e. Unterrichtungsrecht</h4>
        <p>Wenn Sie Ihr Berichtigungs-, Löschungs- oder Einschränkungsrecht gegenüber uns geltend gemacht haben,
            sind wir dazu verpflichtet, allen Empfängern, denen wir Ihre personenbezogenen Daten offengelegt
            haben, die Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer Daten mitzuteilen, es
            sei denn, dies erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand
            verbunden. </p>

        <h4>f. Recht auf Datenübertragbarkeit</h4>
        <p>Sie haben unter der nachfolgenden Bedingung das Recht, die personenbezogenen Daten, die Sie uns
            bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten und
            das Recht, dass diese Daten einem anderen Verantwortlichen übermittelt werden: </p>

        <ul>
            <li>Die Verarbeitung beruht auf einer Einwilligung gemäß Art. 6 (1) lit. a oder Art. 9 (2) lit. a
                DSGVO oder auf einem Vertrag gemäß Art. 6 (1) lit. b und
            </li>
            <li>die Verarbeitung erfolgt mithilfe automatisierter Verfahren.</li>
        </ul>
        <p>Sie haben dabei das Recht zu erwirken, dass wir Ihre personenbezogenen Daten direkt an einen anderen
            Verantwortlichen übermitteln, soweit dies technisch machbar ist und Freiheiten und Rechte anderer
            Personen hierdurch nicht beeinträchtigt werden. </p>

        <p>Dieses Recht auf Datenübertragbarkeit gilt dann nicht, wenn die Verarbeitung für die Wahrnehmung
            einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher
            Gewalt erfolgt, die uns übertragen wurde. </p>

        <h4>g. Widerspruchsrecht</h4>
        <p>Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen
            die Verarbeitung Ihrer personenbezogenen Daten, die auf von Art. 6 (1) lit. e oder lit. f DSGVO
            beruht, Widerspruch einzulegen. Dies gilt auch für ein auf diese Bestimmungen genanntes
            Profiling. </p>
        <p>Wir verarbeiten nach einem Widerspruch Ihre personenbezogenen nicht mehr, es sei denn, wir können
            zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
            Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung
            von Rechtsansprüchen.</p>

        <p>Wenn wir Ihre personenbezogenen Daten verarbeiten, um Direktwerbung zu betreiben, haben Sie das
            Recht, jederzeit Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten zum Zwecke
            derartiger Werbung einzulegen. Dies gilt auch für Profiling, soweit es mit der Direktwerbung in
            Verbindung steht. </p>

        <p>Wenn Sie der Verarbeitung Ihrer personenbezogenen Daten zu Zwecken der Direktwerbung widersprechen,
            werden wir diese nicht mehr für diese Zwecke verarbeiten.</p>

        <p>Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft
            – ungeachtet der RL 2002/58/EG (Datenschutzrichtlinie für elektronische Kommunikation) – Ihren
            Widerspruch mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen
            verwendet werden. </p>

        <h4>h. Widerrufsrecht</h4>
        <p>Sie haben gem. Art. 7 (3) DSGVO das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den
            Widerruf der Einwilligung wird die Rechtmäßigkeit der Verarbeitung nicht rückwirkend unwirksam. </p>

        <h4>i. Beschwerderecht bei einer Aufsichtsbehörde</h4>
        <p>Sie haben das Recht auf Beschwerde bei einer Aufsichtsbehörde, unbeschadet eines anderweitigen
            verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs. Sie können insbesondere im Mitgliedstaat
            Ihres Wohnortes, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes Ihr Beschwerderecht
            geltend machen, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen
            die DSGVO verstößt.</p>

        <p>Eine Übersicht über die jeweiligen Landesdatenschutzbeauftragten der Länder sowie deren Kontaktdaten
            finden Sie unter dem folgenden Link:</p>
        <p>
            <nuxt-link to="https://www.bfdi.bund.de/DE/Service/Anschriften/anschriften_table.html"
                target="_blank">https://www.bfdi.bund.de/DE/Service/Anschriften/anschriften_table.html</nuxt-link>
        </p>

        <h2>9. Aktualität und Änderung dieser Daten­schutz­bestim­mungen</h2>
        <p>Stand: Februar 2025</p>
    </article>
</template>

<style lang="scss" scoped>
article {
    padding: 0 1rem;
}
</style>

<script>
export default {
  name: "CookieConsent",
  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://delivery.consentmanager.net/delivery/cookieinfo.php?cdid=f687c57761de&l=automatic";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>
